(() => {
  function initialize(root) {
    if (root.dataset.extrasReady) return;
    root.dataset.extrasReady = 'true';
    const sports = root.querySelector('[data-sports]');
    const sportsMini = root.querySelector('[data-spf-sports]');
    if (sports && sportsMini) {
      const syncSports = () => { sportsMini.hidden = !sports.checked; };
      sports.addEventListener('change', syncSports);
      syncSports();
    }
    const box = root.querySelector('[data-myths]');
    const dataEl = root.querySelector('[data-myth-data]');
    const scoreEl = root.querySelector('[data-myth-score]');
    if (!box || !dataEl) return;
    let items = [];
    try { items = JSON.parse(dataEl.textContent); } catch (e) { return; }
    let answered = 0;
    let correct = 0;
    const setScore = () => {
      if (!scoreEl) return;
      scoreEl.textContent = answered
        ? `${correct} correct out of ${answered} answered (${items.length} total)`
        : `0 of ${items.length} answered`;
    };
    setScore();
    items.forEach(item => {
      const kind = item[0];
      const card = document.createElement('div');
      card.className = 'dt-myth';
      const statement = document.createElement('p');
      statement.className = 'dt-myth__s';
      statement.textContent = item[1];
      const buttons = document.createElement('div');
      buttons.className = 'dt-myth__btns';
      const result = document.createElement('div');
      result.className = 'dt-myth__r';
      result.hidden = true;
      result.setAttribute('aria-live', 'polite');
      const made = ['myth', 'fact'].map(label => {
        const button = document.createElement('button');
        button.type = 'button';
        button.dataset.answer = label;
        button.textContent = label === 'myth' ? 'Myth' : 'Fact';
        buttons.appendChild(button);
        return button;
      });
      made.forEach(button => button.addEventListener('click', () => {
        const right = button.dataset.answer === kind;
        made.forEach(b => { b.disabled = true; });
        button.classList.add('is-picked');
        result.className = `dt-myth__r ${right ? 'is-right' : 'is-wrong'}`;
        result.textContent = '';
        const head = document.createElement('strong');
        head.textContent = `${right ? 'Nailed it!' : 'Not quite, and that’s ok.'} It’s a ${kind}.`;
        result.appendChild(head);
        result.appendChild(document.createTextNode(item[2]));
        result.hidden = false;
        answered += 1;
        if (right) correct += 1;
        setScore();
      }));
      card.appendChild(statement);
      card.appendChild(buttons);
      card.appendChild(result);
      box.appendChild(card);
    });
  }
  document.querySelectorAll('[data-teen-learning]').forEach(initialize);
  document.addEventListener('shopify:section:load', event => {
    const root = event.target.querySelector('[data-teen-learning]');
    if (root) initialize(root);
  });
})();
